import { ViewMore as ViewMoreComponent } from "@ecologi/react-components/src/ViewMore";
import { useFullPost, forkResult } from "../../lib";

function ViewMoreListItem({ item }: any) {
  const { result, itemTypeForPath } = useFullPost(item);

  return forkResult(
    {
      data: (fullPost) => (
        <ViewMoreComponent.ListItem
          item={item}
          fullPost={fullPost}
          type={itemTypeForPath}
        />
      ),
    },
    result
  );
}

export default function ViewMore({ data }: any) {
  return (
    <ViewMoreComponent data={data}>
      {data.posts.map((post: any, idx: number) => (
        <ViewMoreListItem key={idx} item={post} />
      ))}
    </ViewMoreComponent>
  );
}
